import React from 'react';
import ImageEnhancer from './components/ImageEnhancer';

function App() {
  return (
    <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
      <ImageEnhancer />
    </div>
  );
}

export default App;
